module.exports = __webpack_public_path__ + "img/ratchetclanc.9fc87526.svg";